module.exports = __webpack_public_path__ + "img/logo.956aa9e6.png";